import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-slate-900 text-white py-2 text-center text-sm font-medium z-50 flex items-center justify-center gap-2"
      data-testid="offline-banner"
    >
      <WifiOff className="h-4 w-4" />
      You are offline. Changes will sync when connection is restored.
    </div>
  );
};

export default OfflineBanner;
